<template>
    <div>
        <div class="flex-container1" :style="skin.header_desktop.nav_bar" id="main_nav">
            <div class="c12">
                <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo">
            </div>
            <div class="c2" :style="skin.header_desktop.nav_bar_text">
                <div v-for="item in filteredCategories" :key="item.category" @click="change_view(item.category)" class="options" :style="getDivStyle('Home')">
                    <span> {{ translate("inicio") }} </span>
                </div>
                <!-- <div v-if="skin.prematch != null ? skin.prematch : true" @click="change_view('main')" class="options"
                    :style="getDivStyle('Sports')">
                    {{ translate("sports") }}
                </div>
                <div v-if="skin.casinoN" @click="change_view('casino')" class="options" :style="getDivStyle('Casino')">
                    {{ translate("casino1") }}
                </div>
                <div v-if="skin.casino_live" @click="change_view('casino_live')" class="options"
                    :style="getDivStyle('CasinoLive')">
                    {{ translate("live casino") }}
                </div>
                <div v-if="skin.bingo" @click="change_view('bingo')" class="options" :style="getDivStyle('Bingo')">
                    BINGO
                </div>
                <div v-if="skin.hipicas" @click="change_view('hipicas')" class="options"
                    :style="getDivStyle('Hipicas')">
                    {{ translate("horse_riding") }}
                </div>
                <div v-if="skin.poker" @click="change_view('poker')" class="options" :style="getDivStyle('Poker')">
                    {{ translate("POKER") }}
                </div> -->
            </div>
            <div v-if="user.token == ''" class="c3">
                <div v-if="skin.register" @click="register" class="style" :style="skin.header_desktop.register_btn">
                    {{ translate("sign_in") }}
                </div>
                <div v-if="skin.login" @click="showLogin" class="style" :style="skin.header_desktop.login_btn"
                    style="white-space: nowrap;">
                    <span>{{ translate("Iniciar Sesión") }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-user w-5 h-5" style="margin-bottom:6px;">
                        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </div>
            </div>
            <div v-if="user.token != ''" class="c4">
                <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.support"
                    class="dropdown nav-item ">
                    <div>
                        <div class="btn-support"
                            :style="skin.header_desktop.support_btn + (this.message_recived ? 'color:white;' : '')"
                            @click="openSupportModalJivo()">
                            <i class="fas fa-comment fa-fw"></i>
                        </div>
                    </div>
                </div>
                <div v-if="skin.header_desktop.balance && (this.screen_width1 > 767)" @click="showBalanceAction"
                    class="nav-item mx-1" :class="skin.my_account.myaccount_type == 'JM' ? '' : 'text-end'"
                    :style="skin.header_desktop.nav_bar_text" style="cursor:pointer">
                    <span class="pr-0 mx-1" style="font-weight: 300;cursor:pointer;">{{
                        user.user_data.data.currency == 'USD' ? user.user_data.data.currency : translate('credits')
                        }}</span>
                    <!-- <i  class="fas fa-coins pr-0 mx-1"></i> -->
                    <span style="font-weight: 800;">{{ user.user_data.data ? new
                        Intl.NumberFormat("de-DE", {
                            minimumFractionDigits:
                                skin.qBet_config.decimalsQty, maximumFractionDigits:
                                skin.qBet_config.decimalsQty
                        }).format(balance.saldo) : 0 }}</span>
                </div>
                <div class="dropdown mx-1">
                    <button class="btn btn-dark dropdown-toggle border-radiu btn-sm" type="button"
                        data-bs-toggle="dropdown" aria-expanded="false" style="border-radius:10px">
                        <span style="margin: 20px; font-weight:800"> {{ user.user_data.data ?
                            user.user_data.data.user_name : '' }}</span><br v-if="this.screen_width1 < 767">
                        <span v-if="this.screen_width1 < 767" class="pr-0 mx-1"
                            style="font-weight: 300;cursor:pointer;">{{
                                user.user_data.data.currency == 'USD' ? user.user_data.data.currency : translate('credits')
                            }}</span>
                        <!-- <i  class="fas fa-coins pr-0 mx-1"></i> -->
                        <span v-if="this.screen_width1 < 767" style="font-weight: 800;">{{ user.user_data.data ? new
                            Intl.NumberFormat("de-DE", {
                                minimumFractionDigits:
                                    skin.qBet_config.decimalsQty, maximumFractionDigits:
                                    skin.qBet_config.decimalsQty
                            }).format(balance.saldo) : 0 }}</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-lg-end">
                        <li><a v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.loginHistory"
                                data-bs-toggle="modal" data-bs-target="#historial_ingresos" class="dropdown-item"
                                href="#"><i class="fa fa-database"></i> {{ translate('option_user') }}</a></li>
                        <li><a v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.changePassword"
                                id="changePasswordBtn" data-bs-toggle="modal" data-bs-target="#changePasswordJm"
                                class="dropdown-item" href="#"><i class="fa fa-key"></i>
                                {{ translate('change_password') }}</a></li>
                        <li><a v-if="skin.header_desktop.userMenu.balanceHistory" @click="getMovements()"
                                data-bs-toggle="modal" data-bs-target="#myAccountZeus" class="dropdown-item" href="#"><i
                                    class="fa fa-history"></i> {{ translate('account_history') }}</a></li>
                        <li><a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#limitModal"><i
                                    class="fa fa-list-ul"></i> {{ translate('Limites') }}</a></li>
                        <li><a v-if="skin.header_desktop.userMenu.sportsRules" @click="terms" class="dropdown-item"
                                href="#"><i class="fa fa-book"></i> {{ translate('regulations') }}</a></li>
                        <li><a v-if="skin.logout" @click="logout" class="dropdown-item" href="#"><i
                                    class="fa fa-power-off"></i> {{ translate('go_out') }}</a></li>
                    </ul>

                </div>
                <div>
                    <languageSelector :skin="skin" :language="language">
                    </languageSelector>
                </div>

            </div>
            <myAccount v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <changePassword v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <misDatos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        </div>
        <div class="modal-container" v-if="isLoginVisible"
            :style="'margin-top:' + contentHeight + '; height:' + (this.screen_width1 < 767 ? (this.screen_heigth1 - 120) + 'px;' : (this.screen_heigth1) + 'px;')">
            <login v-if="isLoginVisible" @close-login="isLoginVisible = false" v-bind:skin="skin"
                v-bind:language="language" v-bind:translation="translation"></login>
        </div>
        <div class="modal fade" id="limitModal" tabindex="-1" aria-labelledby="limitModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="background-color: #1c1c1c;" :style="skin.header_desktop.nav_bar_text">
                    <div class="modal-header">
                        <h5 class="modal-title" id="limitModalLabel">{{ translate('max_lim') }}</h5>
                        <button type="button" style="background-color: #fff;" class="btn-close btn-outline-light"
                            data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body" style="background-color: #1c1c1c; font-size: 12px;">
                        <div class="text-center">
                            • <span>{{ translate('max_lim') }}</span> •
                        </div>
                        <div class="d-flex my-1 mb-1">
                            <span style="width:50%">PragmaticPlay</span>
                            <span style="width:50%;text-align: right;">160.000</span>
                        </div>
                        <div class="d-flex my-1 mb-1">
                            <span style="width:50%">VivoGaming</span>
                            <span style="width:50%;text-align: right;">160.000</span>
                        </div>
                        <div class="d-flex my-1 mb-1">
                            <span style="width:50%">Ezugi</span>
                            <span style="width:50%;text-align: right;">160.000</span>
                        </div>
                        <div class="d-flex my-1 mb-1">
                            <span style="width:50%">Caballos</span>
                            <span style="width:50%;text-align: right;">160.000</span>
                        </div>
                        <div class="d-flex my-1 mb-1">
                            <span style="width:50%">Slots</span>
                            <span style="width:50%;text-align: right;">8.000</span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        • <span style="font-size: small;">{{ translate('condition') }} </span>.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import myAccount from "./my_account.vue";
import router from "../../../router";
import languageSelector from './language.vue';
import login from "./login.vue";
import changePassword from './changePassword.vue';
import misDatos from "./mis_datos.vue";
export default {
    name: "Header",
    props: ['skin', 'language', 'translation'],
    data() {
        return {
            showBalance: false,
            screen_width1: window.innerWidth,
            screen_heigth1: window.innerHeight,
            isLoginVisible: false,
            displayModal: false,
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            }
        }
    },
    components: {
        login,
        changePassword,
        languageSelector,
        myAccount,
        misDatos
    },
    methods: {
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        openSupportModalJivo() {
            const jivoElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoElement) {
                    jivoElement.style.display = 'none';
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoElement) {
                    jivoElement.style.display = 'block';
                    jivo_api.open()
                }
                setTimeout(() => {
                    jivo_api.open()
                }, 500);
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);

            }
        },
        sizeControl() {
            this.screen_width1 = window.innerWidth;
            this.screen_heigth1 = window.innerHeight;
        },
        showLogin() {
            this.isLoginVisible = true;
        },
        getDivStyle(view) {
            if (this.$route.name.toLowerCase() === view.toLowerCase()) {
                return {
                    backgroundImage: `${this.skin.main_active_1}`
                };
            } else {
                return {};
            }
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        change_view(view) {
            if ((view == "casino_live" || view == "casino" || view == "hipicas" || view == "bingo" || view == "poker" || view ==
                "crazzyWin") && this.user.token == '') {
                this.isLoginVisible = true;
            }
            else {
                if (view == "casino_live") {
                    router.push({ name: "CasinoLive" }).catch(() => { })
                }
                else if (view == "casino") {
                    router.push({ name: "Casino" }).catch(() => { })
                }
                else if (view == "crazzyWin") {
                    router.push({ name: "CrazzyWin" }).catch(() => { })
                }
                else if (view == "bingo") {
                    router.push({ name: "Bingo" }).catch(() => { })
                }
                else if (view == "hipicas") {
                    router.push({ name: "Hipicas" }).catch(() => { })
                }
                else if (view == "poker") {
                    router.push({ name: "Poker" }).catch(() => { })
                }
                else if (view == "lobby") {
                    router.push({ name: "Home" }).catch(() => { })
                }
                else if (view == "main") {
                    router.push({ name: "Sports" }).catch(() => { })
                }
                else if (view == "mainlive") {
                    router.push({ name: "Sportslive" }).catch(() => { })
                }

            }
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language ==
                'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" +
                    this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                //let domain_formated = "admin.championred.bet";
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        }
    },
    computed: {
        filteredCategories() {
      return this.$props.skin.categories.filter(category => category.active);
    },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        contentHeight() {
            return this.$store.getters["getHeaderHeight"] + "px";
            
        },
        user() {
            let config = this.$store.getters['getConfig'];
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = config.SkinConfig.main.newbonus ? data.user_data.data.available_balance +
                    data.user_data.data.bonus + data.user_data.data.frozen : data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
            }
            return data;
        }
    },
    mounted() {
        if (this.skin.header_desktop.nav_bar_item_hover_color) {
            document.documentElement.style.setProperty('--hover-color', this.skin.header_desktop.nav_bar_item_hover_color);
        }
        this.$store.dispatch("setHeaderHeight", document.getElementById("main_nav").offsetHeight);
        window.addEventListener('resize', () => { this.sizeControl(); });
    },
    watch: {
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    },
    created() {
        const self = this;
        let balanceRequestTime = 8000;
        var saldo_request = setInterval(function () {
            try {
                if (self.user.user_data.data) {
                    self.$store.dispatch('getProfile', {
                        token: self.user.token,
                        site_id: self.user.site_id,
                        site: self.user.site,
                        prefix: self.user.prefix,
                        playerId: self.user.user_data?.data?.user_id,
                        source: "main"
                    });
                }
            } catch (error) {
                this.$store.dispatch('logOut');
                clearInterval(saldo_request);
            }
        }, balanceRequestTime);

    }
};


</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@500&display=swap');

.modal-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000719;
    /* Fondo semitransparente */
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 50px;
    /* Asegura que esté sobre otros elementos */
}

.modal-root {
    border-radius: 8px;
    width: 100%;
    max-width: 100%;
    /* Establece un ancho máximo fijo */
    height: 90%;
    /* Altura fija relativa al viewport */
    overflow-y: auto;
    /* Activa scroll cuando el contenido excede la altura fija */
    transform: scale(0.9);
    animation: modalAppear 0.3s ease-out forwards;
}

.flex-container1 {
    display: flex;
    height: 65px;
    padding: 12.25px 20px;
}

.c12 {
    width: 17%;
    display: flex-start;
    justify-content: center;
    align-items: center;

    /* Cambiado de align-content a align-items */
}

.c12 img {
    max-width: 100%;
    height: 100%;
    /* Asegura que la imagen no se desborde horizontalmente */
    max-height: 100%;
    /* Asegura que la imagen no se desborde verticalmente */
    object-fit: contain;
    /* Ajusta la imagen dentro del contenedor sin distorsión */
}

.c2 {
    width: 63%;
    display: flex;
    justify-content: center;
    align-content: center;
    column-gap: 10%;
}

.c3 {
    width: 20%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.c4 {
    width: 20%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

}

.options {
    font-family: "Open Sans";
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
    padding: 0 7px;
    border-radius: 9999px;
    line-height: 11.2px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

.options:hover {
    color: var(--hover-color);
}


.style {
    gap: 5px;
    display: flex;
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    padding: 0 14px;
    border-radius: 9999px;
    height: 100%;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

.style:hover {
    transform: scale(1.1);
    /* Aumenta ligeramente el tamaño */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);
    /* Sombra suave */
}

@media (max-width: 767px) {
    .options {
        display: none;
    }
}

.btn-support {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    min-width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
}
</style>